import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Label,
  Textarea,
} from '@roger/ui-components';
import type { NotesState } from '../assessmentFormTypes';

interface NotesSectionProps {
  state: NotesState;
  onChange: (update: Partial<NotesState>) => void;
}

const FIELDS: { label: string; field: keyof NotesState }[] = [
  { label: 'Wound Care Notes', field: 'woundCareNotes' },
  { label: 'Treatment Performed', field: 'treatmentPerformed' },
  { label: 'Patient Response', field: 'patientResponse' },
  { label: 'Additional Info', field: 'additionalInfo' },
];

const NotesSection: React.FC<NotesSectionProps> = ({ state, onChange }) => (
  <AccordionItem value='notes' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Notes
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      {FIELDS.map(({ label, field }) => (
        <div key={field} className='space-y-1'>
          <Label className='text-xs'>{label}</Label>
          <Textarea
            placeholder={`${label}...`}
            value={state[field]}
            onChange={e => onChange({ [field]: e.target.value })}
            textareaSize='sm'
            className='resize-none'
            rows={2}
          />
        </div>
      ))}
    </AccordionContent>
  </AccordionItem>
);

export default NotesSection;
